import { useCallback } from 'react'
import { toast } from 'react-toastify'

const clean  = value => value ? `'${value}'` : ''

export default ({ addItem, deleteItem, updateItem, setShowNew }) => {

  const onDelete = useCallback(
    (id, item) => deleteItem(id).then(() => {
      toast.success('User deleted', {
        position: toast.POSITION.TOP_RIGHT,
      })
      setShowNew(true)
    }),
    [deleteItem, setShowNew],
  )
  const onSave = useCallback(
    item => {
      return updateItem(item.userId, item).then(() =>
        toast.success(`User ${clean(item.login)} updated`, {
          position: toast.POSITION.TOP_RIGHT,
        }))
    },
    [updateItem],
  )

  const onAdd = useCallback(
    item => {
      return addItem(item).then(() => {
        toast.success(`User ${clean(item.login)} added`, {
          position: toast.POSITION.TOP_RIGHT,
        })
        setShowNew(true)
      })
    },
    [addItem, setShowNew],
  )
  return {
    onAdd,
    onSave,
    onDelete,
  }
}
